import Reveal from '@/components/base/Reveal';

export default function FollowCta() {
  return (
    <section className="bg-background-50 px-4 pb-20 pt-4 md:px-6 md:pb-28 md:pt-6">
      <Reveal>
        <div className="relative mx-auto w-full max-w-[1200px] overflow-hidden rounded-lg">
          <img
            src="https://readdy.ai/api/search-image?query=Deep%20crimson%20and%20amber%20abstract%20editorial%20background%20with%20flowing%20inklike%20curves%20and%20fine%20paper%20grain%2C%20dramatic%20dark%20tones%20for%20bright%20text%20contrast%2C%20artistic%20non%20realistic%20composition%2C%20high%20detail%2C%20premium%20magazine%20atmosphere&width=1600&height=800&seq=hlgl-cta-01&orientation=landscape"
            alt="关注黑料官方引导配图"
            title="关注黑料官方 全平台社交矩阵"
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/65 to-foreground-950/45"></div>

          <div className="relative z-10 flex flex-col gap-8 px-6 py-14 md:px-14 md:py-20">
            <div className="max-w-2xl">
              <span className="font-label text-xs tracking-[0.34em] text-accent-300">
                FOLLOW US
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
                别错过任何一条来自黑料官方的消息
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-background-100 md:text-base">
                把四个渠道都关注上，或者先从一个开始。之后无论哪边发布新内容，你都能第一时间收到提醒。
              </p>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#matrix"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-background-100"
              >
                <i className="ri-add-line text-base"></i>
                前往社交矩阵
              </a>
              <a
                href="#feed"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-article-line text-base"></i>
                先看看最近的内容
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}